import './TControlNotFound.scss'
export let TControlNotFound = ({ title, icon, descr }) => {
  return (
    <div className="not-found-message">
      <div className="error-icon">{icon ? icon : '😔'}</div>
      <h2>{title}</h2>
      <p>{descr}</p>
    </div>
  );
};